import { PrimeReactProvider as PrimeReactApiProvider } from 'primereact/api';

type Props = {
  children: React.ReactNode;
};

export const PrimeReactProvider = ({ children }: Props) => (
  <PrimeReactApiProvider>{children}</PrimeReactApiProvider>
);
